<template>
  <div class="space-y-6">
    <div>
      <h1 class="text-3xl font-bold mb-2">{{ title }}</h1>
      <p class="text-muted-foreground">{{ subtitle }}</p>
    </div>

    <div v-if="sector === 'compras'" class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <JsonKpiChartCard
        v-for="c in comprasJsonChartKpis"
        :key="c.kpiName"
        :class="c.wide ? 'lg:col-span-2' : ''"
        :year="currentYear"
        sector="compras"
        :kpiName="c.kpiName"
        :tall-chart="Boolean(c.tallChart || c.wide)"
        :readonly="isEmbedReadonly"
      />
    </div>

    <div v-if="sector === 'operacoes'" class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <JsonKpiChartCard
        v-for="c in operacoesJsonChartKpis"
        :key="c.kpiName"
        :class="c.wide ? 'lg:col-span-2' : ''"
        :year="currentYear"
        sector="operacoes"
        :kpiName="c.kpiName"
        :tall-chart="Boolean(c.tallChart || c.wide)"
        :readonly="isEmbedReadonly"
      />
    </div>

    <div v-if="sector === 'sucesso'" class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <JsonKpiChartCard
        v-for="c in sucessoJsonChartKpis"
        :key="c.kpiName"
        :class="c.wide ? 'lg:col-span-2' : ''"
        :year="currentYear"
        sector="sucesso"
        :kpiName="c.kpiName"
        :tall-chart="Boolean(c.tallChart || c.wide)"
        :readonly="isEmbedReadonly"
      />
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <KPIChartCard
        v-for="kpi in sectorDefs"
        :key="kpi.key"
        :sector="sector"
        :kpiKey="kpi.key"
        :kpiName="kpi.name"
        :metas="kpi.metas"
        :format="kpi.format"
        :readonly="isEmbedReadonly"
      />
    </div>
  </div>
</template>

<script>
import KPIChartCard from '@/components/kpi/KPIChartCard.vue'
import JsonKpiChartCard from '@/components/kpi/JsonKpiChartCard.vue'
import { months } from '@/lib/kpi-data'

export default {
  name: 'SectorDashboard',
  components: { KPIChartCard, JsonKpiChartCard },
  props: {
    sector: { type: String, required: true },
    title: { type: String, required: true },
    subtitle: { type: String, required: true },
  },
  computed: {
    isEmbedReadonly() {
      return Boolean(this.$route && this.$route.meta && this.$route.meta.readonly)
    },
    kpisData() {
      return this.$store.state.kpis.data || {}
    },
    currentYear() {
      return new Date().getFullYear()
    },
    comprasJsonChartKpis() {
      return [
        { kpiName: 'laerdal_ebook' },
        // { kpiName: 'laerdal_livro_fisico' },
        { kpiName: 'orcado_combo', tallChart: true },
        { kpiName: 'precificado_combo', tallChart: true },
      ]
    },
    operacoesJsonChartKpis() {
      return [
        { kpiName: 'ebooks_operacoes', tallChart: true },
        { kpiName: 'livro_operacoes', tallChart: true },
        { kpiName: 'antecedencia_livros_ebooks_menor_30', tallChart: true },
        { kpiName: 'antecedencia_livros_ebooks_maior_30', tallChart: true },
      ]
    },
    sucessoJsonChartKpis() {
      return [
        { kpiName: 'qtd_conversas', tallChart: true },
        { kpiName: 'reembolsos_solicitados_vs_revertidos', tallChart: true },
      ]
    },
    sectorDefs() {
      const defs = this.$store.getters['kpis/getDefsForSector'](this.sector) || []
      return defs.map((d) => ({
        ...d,
        metas: months.map((m) => Number(this.kpisData?.[this.sector]?.[d.key]?.[m]?.meta ?? 0)),
      }))
    },
  },
}
</script>

